import { useSyncExternalStore } from 'react';

const subscribe = (listener: () => void) => {
  document.addEventListener('visibilitychange', listener);
  window.addEventListener('focus', listener);
  return () => {
    document.removeEventListener('visibilitychange', listener);
    window.removeEventListener('focus', listener);
  };
};

/** True while the page is visible (tab in front, window not minimised). */
export const useDocumentVisible = () =>
  useSyncExternalStore(subscribe, () => document.visibilityState === 'visible');
